import React from 'react';
import { useNavigate } from "react-router-dom";

const Checkbox2 = ({ checked, onChange }) => {
  const navigate = useNavigate();

  return (
    <div className="flex justify-between items-center w-full">
      <label className="flex items-center gap-3 cursor-pointer ">
        <input
          type="checkbox"
          className="checkbox [--chkbg:theme(colors.darkerGreen)] [--chkfg:black] checked:border-darkerGreen"
          name="securityAgreement"
          checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        />
        <span className="label-text text-sm text-grayy">Oturumum açık kalsın.</span>
      </label>
      <button 
        type="button"
        className="text-sm text-customBlue cursor-pointer hover:underline text-left"
        onClick={() => navigate("/sifre_yenileme")} 
      >
        Şifremi unuttum?
      </button>
    </div>
  );
};

export default Checkbox2;
